import { ModeForm } from "constants/enum";

import {
  useGetManyBaseRequestHistoryControllerRequestHistoryEntity,
  useGetOneBaseRequestControllerRequestEntity,
} from "generated";
import { useNotification } from "hooks/useNotification";
import { useParams } from "react-router-dom";

import { RequestForm } from "./RequestForm";

export const RequestDetailComponent = () => {
  const { id } = useParams();
  const { data: history, refetch: refetchHistory } =
    useGetManyBaseRequestHistoryControllerRequestHistoryEntity({
      s: JSON.stringify({
        requestId: {
          $eq: id,
        },
      }),
      limit: 1,
      join: ["createdBy"],
    });
  const { data, error } = useGetOneBaseRequestControllerRequestEntity(
    id as string,
    {
      join: [
        `client`,
        `pic`,
        `assignee`,
        `requestAssignees`,
        `requestAssignees.user`,
      ],
    }
  );

  useNotification(error);

  return (
    <RequestForm
      title="General information"
      handleSubmitForm={() => {}}
      data={data?.data as any}
      mode={ModeForm.View}
      isRefetch
      history={history?.data.data[0]}
    />
  );
};
